import * as React from "react";
import { SVGProps } from "react";
const SvgLogoWatsonx = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} {...props}>
    <path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#878d96",
        fillOpacity: 1,
      }}
      d="M8 3.715A2.784 2.784 0 0 0 5.215 6.5v3.715A2.784 2.784 0 0 0 8 13a2.784 2.784 0 0 0 2.785-2.785V6.5A2.784 2.784 0 0 0 8 3.715ZM6.027 7.367h3.946V9.34H6.027ZM8 12.187a1.982 1.982 0 0 1-1.973-1.972v-.063h3.946v.063A1.982 1.982 0 0 1 8 12.188Zm1.973-5.632H6.027V6.5a1.972 1.972 0 1 1 3.946 0Zm4.832 1.437-3.09-2.887v4.227c0 1.027.832 1.855 1.855 1.855a1.852 1.852 0 0 0 1.856-1.855c0-.516-.227-1.008-.621-1.34Zm-1.235 2.383a1.04 1.04 0 0 1-1.043-1.043V6.965l1.727 1.61c.21.179.332.437.34.71a1.045 1.045 0 0 1-1 1.09ZM.574 9.332c0 1.027.828 1.855 1.856 1.855a1.855 1.855 0 0 0 1.855-1.855V5.105l-3.09 2.887c-.39.336-.617.824-.62 1.34Zm1.149-.727 1.75-1.64v2.367a1.04 1.04 0 0 1-1.043 1.043 1.044 1.044 0 0 1-1.047-1.043.965.965 0 0 1 .34-.723Zm5.812-6.98C7.535.727 6.81 0 5.91 0a1.624 1.624 0 1 0 0 3.25c.899 0 1.625-.727 1.625-1.625Zm-2.437 0a.812.812 0 1 1 .812.813.825.825 0 0 1-.812-.813ZM10.09 0C9.19 0 8.465.727 8.465 1.625S9.19 3.25 10.09 3.25a1.624 1.624 0 1 0 0-3.25Zm0 2.438a.812.812 0 1 1 .812-.813.825.825 0 0 1-.812.813Zm0 0"
    />
  </svg>
);
export default SvgLogoWatsonx;
